(function ($) {
    'use strict';

    $(document).ready(function () {
        var flexsliderDOM = $('.flexslider'),
            // flexslider,
            navbarCollapse = $('.navbar-collapse'),
            opportunityChecked = [],
            opportunityElement = {};

        window.mobileCheck();
        window.buildNavigation();
        window.textResizerInit();
        window.parallaxInit();
        window.addFileReaderDownloadLinks();

        $('#content').breakLongURLs();
        $('body').convertSVGsToInline();
        $('#example-table').addMobileTableHeaders();

        if (flexsliderDOM.length !== 0) {
            flexsliderDOM.flexslider({
                animation: 'slide',
                animationLoop: true
            });

            // flexslider = flexsliderDOM.data('flexslider');
        }

        $('.slides .slide, .jumbotron').detectBackgroundImageColor();

        // Change the breadcrumb href
        // $(".breadcrumb ol li:nth-child(2) a").attr("href", "#");

        // Display image underneath header for view & basic page drupal
        function getHeaderImg () {
            var img = $(".view-header img").attr("src"),
                imgBasicPage = $(".field--name-field-bg-header img").attr("src");

            if (img !== undefined || imgBasicPage !== undefined) {
                $(".header-bg").css("display", "block");
            }

            $(".header-bg img").attr("src", img);
            $(".header-bg img").attr("src", imgBasicPage);
        }

        getHeaderImg();

        // Research opportunity page -> Display Search result
        if ($(".view").hasClass("view-id-view1") && window.location.search !== "") {
            $(".container-opportunity").css("display", "block");
            $(".view-content .views-row:first-child .views-field-nothing").css("display", "block");
        }
        // Research opportunity page -> Display Category list linked to Search result for Category
        if ($(".view").hasClass("view-id-view1") && window.location.search === "") {
            $(".view-content .views-row:first-child .views-field-nothing-2 .view-content").css("display", "flex");
            $(".view-content .views-row .views-row .views-field-nothing-2 .view-content").css("display", "none");
            // Total Result
            $(".view-content .views-row .views-field-nothing ").css("display", "none");
            // Remove pager
            $(".pager").css("display", "none");
        }

        // Student page -> Hide Total nb of student
        if ($(".view").hasClass("view-id-student_profiles")) {
            $(".view-id-student_profiles .view-content").wrap("<div class='content-student'></div>");
        }

        // Alumni page -> Hide Total nb of student
        if ($(".view").hasClass("view-id-alumni")) {
            $(".view-id-alumni .view-content").wrap("<div class='content-student alumni'></div>");
        }

        // FAQ page -> Display Search result
        if ($(".view").hasClass("view-id-faq") && window.location.search !== "") {
            $(".question-container").css("display", "block");
            $(".view-content .views-row:first-child .views-field-nothing").css("display", "block");
        }

        // FAQ page -> Display Topic List linked to Search result for Topic
        if ($(".view").hasClass("view-id-faq") && window.location.search === "") {
            $(".view-content .views-row:first-child .views-field-nothing-2 .view-content").css("display", "flex");
            $(".view-content .views-row .views-row .views-field-nothing-2 .view-content").css("display", "none");
            // Total Result
            $(".view-content .views-row .views-field-nothing ").css("display", "none");
        }

        // View pages -> Display total result underneath filter criteria
        function getTotalResult () {
            var result = $(".total-result").html();

            $('.total').html(result);
        }

        getTotalResult();

        $(window).resize(function () {
            window.mobileCheck();

            if (!window.isMobile) {
                // hide open mobile nav when sizing up to desktop
                navbarCollapse.height('');
            }
        });

        $('#edit-submit-student-profiles').click(function () {
            $('#edit-first-name').val('');
            $('#edit-last-name').val('');
        });

        // Download Opportunities in RO
        $('#download').click(function () {
            var link = $('.csv-feed.views-data-export-feed a').attr('href'),
                oppChecked = [],
                thisBtn = $(this),
                nidLink = '&nid=';

            // Check which checbox is check
            $('.custom-checkbox input:checkbox').each(function () {
                var $this = $(this);

                if ($this.is(':checked')) {
                    oppChecked.push($this.attr('id'));
                }
            });

            // Add the checked box into the link to download
            $.each(oppChecked, function (index, value) {
                if (value === 'checkAll') {
                    thisBtn.attr('href', link);
                    return;
                } else {
                    if (index === 0) {
                        nidLink += value;
                    } else {
                        nidLink += '%7C' + value;
                    }
                }
            });

            link += nidLink;
            link = link.replace('http', 'https');

            $(this).attr('href', link);
        });

        // Research Opportunity Check All checkbox
        $('#checkAll').click(function () {
            if (this.checked) {
                $('.container-opportunity input:checkbox').each(function (){
                    if (!this.checked) {
                        this.click();
                    }
                });
            } else {
                $('.container-opportunity input:checkbox').not(this).prop('checked', this.checked);
                opportunityChecked = [];
                $('#edit-result-opportunity').html('See below the Research Opportunities selected:');
            }
        });

        // RO check if checkbox is unchecked
        $('.container-opportunity input:checkbox').click(function () {
            var opportunityID = $(this).attr('id');

            if (!$(this)[0].checked) {
                // Remove the checked All checbox if one of the checkbox is unchecked
                $('#checkAll').prop('checked', '');

                // Remove content from Email textarea
                opportunityChecked = $.grep(opportunityChecked, function (e){
                    return e.id !== opportunityID;
                });
            } else {
                // Add content from Opportunity to Email textarea
                opportunityElement = {};

                opportunityElement.id = opportunityID;
                opportunityElement.value = $('#container-' + opportunityID + ' .info').text();

                opportunityChecked.push(opportunityElement);
            }

            $('#edit-result-opportunity').html('See below the Research Opportunities selected:');

            $(opportunityChecked).each(function () {
                $('#edit-result-opportunity').append(this.value);
            });
        });

        // Research Opportunity download button
        $('#btn-download').on('click', function () {
            var divContents = $('#container-opportunity1').html(),
                printWindow = window.open('', '', 'height=400,width=800');

            printWindow.document.write('<html><head><title>DIV Contents</title>');
            printWindow.document.write('</head><body >');
            printWindow.document.write(divContents);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.print();
        });
    });

    // Drupal add checkbox into RO view
    $('.task .custom-checkbox').append("<input type='checkbox' class='custom-control-input' id='checkAll'><label class='custom-control-label' for='checkAll'><span class='visually-hidden'>checkAll</span></label>");

    function getIdCheckbox () {
        $('.container-opportunity').each(function () {
            var id = $(this).find('.nid').html();

            $(this).find('.custom-checkbox').append("<input type='checkbox' class='custom-control-input' id='"+ id +"'><label class='custom-control-label' for='"+ id +"'><span class='visually-hidden'>Checkbox</span></label>");
        });
    }

    getIdCheckbox();

    $(window).on('load', function () {
        // Homepage page -> Display image for Category Research Opportunity
        function getCategoryImg () {
            $('.view-homepage-category .view-content').children('.views-row').each(function () {
                var categoryImg = $(this).find("img").attr("src");

                categoryImg = categoryImg.replace('/styles/large/public/', '/');

                categoryImg = categoryImg.split('?')[0];

                $(this).find('.research-category').css('background-image', 'url("' + categoryImg + '")');
            });

            $('.research').css('display', 'block');
        }
        getCategoryImg();

        // Modal creation in Research Opportunity
        $('#webform-submission-send-opportunities-add-form').wrap('<div class="modal fade" id="emailModal" tabindex="-1" role="dialog" aria-labelledby="emailModalLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-body"></div></div></div></div>');
        $('#modal-header').prependTo( $('.modal-content') );
    });

}(jQuery));
